import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "../Reveal";
import { IMAGES } from "../../data/site";

export const Intro = () => (
  <section id="about" data-testid="intro-section" className="section-pad bg-warm">
    <div className="container-cando grid items-center gap-14 lg:grid-cols-12">
      <div className="lg:col-span-6">
        <Reveal>
          <Eyebrow>Who We Are</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="h2 mt-6 max-w-lg text-charcoal">
            A General Contractor Built Around Getting It Right.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="body-lg mt-7 max-w-xl text-mute">
            Cando Construction Services Ltd. is an Edmonton-based construction company specializing in
            framing, home additions, basement renovations and interior improvements.
          </p>
          <p className="body-lg mt-5 max-w-xl text-mute">
            We work directly with homeowners from the initial walkthrough through the final punch list,
            keeping communication clear, the job site organized and the project moving toward completion.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <Link to="/#process" data-testid="intro-cta" className="link-arrow group mt-9">
            Learn About Cando
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>

      <div className="lg:col-span-6">
        <Reveal delay={0.15} className="relative">
          <div className="absolute -left-4 -top-4 hidden h-full w-full border border-bronze/50 lg:block" />
          <div className="relative overflow-hidden">
            <img
              src={IMAGES.intro}
              alt="Finished interior by Cando Construction"
              loading="lazy"
              className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
              data-testid="intro-image"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
